module.exports = __webpack_public_path__ + "img/f64f3a4.png";